var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-md-8"},[_c('update-address')],1),_c('div',{staticClass:"col-lg-4 col-md-4"},[_c('update-password')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }